import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "./AuthContext";

const EmpresaContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EmpresaProvider = ({ children }) => {
  const { user, token } = useAuth();
  const [empresas, setEmpresas] = useState([]);
  const [empresaActual, setEmpresaActual] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && token) {
      // Ensure axios has the token
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      setLoading(true);
      
      // Check if user has specific empresas assigned
      if (user.empresas && user.empresas.length > 0) {
        // Use user's assigned empresas directly
        setEmpresas(user.empresas || []);
        
        // Auto-select first empresa for restricted users
        if (user.empresas && user.empresas.length > 0) {
          setEmpresaActual(user.empresas[0]);
          localStorage.setItem("empresaActualId", user.empresas[0].id);
        }
        setLoading(false);
      } else {
        // Superadmin or unrestricted users - fetch all empresas
        fetchEmpresas();
      }
    } else {
      setEmpresas([]);
      setEmpresaActual(null);
      setLoading(false);
    }
  }, [user, token]);

  const fetchEmpresas = async () => {
    try {
      // Double-check that we have a token before making the request
      const currentToken = localStorage.getItem("token");
      if (!currentToken) {
        console.log("No token available for fetchEmpresas");
        setLoading(false);
        return;
      }
      
      const response = await axios.get(`${API}/empresas`, {
        headers: {
          "Authorization": `Bearer ${currentToken}`
        }
      });
      setEmpresas(response.data);
      // NO autoseleccionar empresa - el usuario la selecciona desde Home
    } catch (error) {
      console.error("Error fetching empresas:", error);
    } finally {
      setLoading(false);
    }
  };

  const cambiarEmpresa = (empresaId) => {
    const empresa = empresas.find(e => e.id === empresaId);
    if (empresa) {
      setEmpresaActual(empresa);
      localStorage.setItem("empresaActualId", empresaId);
    } else {
      // Si no se encontró la empresa, al menos guardar el ID
      localStorage.setItem("empresaActualId", empresaId);
    }
  };

  // Recuperar empresa guardada al cargar
  useEffect(() => {
    const savedEmpresaId = localStorage.getItem("empresaActualId");
    if (savedEmpresaId && empresas.length > 0 && !empresaActual) {
      const empresa = empresas.find(e => e.id === savedEmpresaId);
      if (empresa) {
        setEmpresaActual(empresa);
      }
    }
  }, [empresas]);

  return (
    <EmpresaContext.Provider value={{ empresas, empresaActual, loading, cambiarEmpresa, fetchEmpresas }}>
      {children}
    </EmpresaContext.Provider>
  );
};

export const useEmpresa = () => {
  const context = useContext(EmpresaContext);
  if (!context) {
    throw new Error("useEmpresa must be used within EmpresaProvider");
  }
  return context;
};
